import React from "react";
import PropTypes from "prop-types";

class UserGuideMob extends React.Component {
    constructor(props) {
        super(props);

        this.handleMail = this.handleMail.bind(this);
    }

    handleMail(event) {
        event.preventDefault();
        const email =
            "mailto:ci_marketing@chubb.com?subject=CI%20App%20Feedback";
        window.location = email;
    }

    render() {
        return (
            <section className="mob-modal">
                <header className="mob-modal__header container wrapper">
                    <a className="icon header__logo-link" href="/">
                        <img
                            src="/img/logo.svg"
                            className="header__logo"
                            alt="Chubb Logo"
                        />
                    </a>
                    <button
                        className="mob-modal__trig"
                        onClick={this.props.closeModal}
                    >
                        <i className="fal fa-times" />
                    </button>
                </header>
                <section className="mob-modal__hero wrapper">
                    <div className="hero__wrap">
                        <h1 className="hero__title">User Guide</h1>
                        <h2 className="hero__subtitle">
                            How to Read Appetite Risk
                        </h2>
                    </div>
                    <section className="user-guide">
                        <dl className="grid__list grid__list--guide">
                            <dt className="grid__item app--strong">
                                Strong Appetite
                            </dt>
                            <dt className="grid__item app--qualified">
                                Qualified; each risk considered on its merits
                            </dt>
                            {/* <dt className="grid__item app--mixed">Qualified; <em class="label-sm">GL+ Product = Green</em></dt>*/}
                            <dt className="grid__item app--limited">
                                Limited or No Appetite
                            </dt>
                            <dt className="grid__item app--na">N/A</dt>
                        </dl>
                        <section className="filter__btn-wrap">
                            <button
                                className="modal-btn modal-btn--feedback"
                                onClick={this.handleMail}
                                data-cta="Email: Further Information"
                            >
                                Send Feedback
                            </button>
                        </section>
                    </section>
                </section>
            </section>
        );
    }
}

export default UserGuideMob;



// WEBPACK FOOTER //
// ./src/components/UserGuideMob.js